import React from "react";

const Home = (props) => {
  return <div>Welcome {props.name}</div>;
};

export default Home;
